import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getScientificAreas } from "../services/school/scientificArea/getScientificAreas";

export const useGetScientificAreasQuery = (data: PagedRequestType) =>
  useQuery(
    ["scientificAreas-pagination", JSON.stringify(data)],
    () => getScientificAreas(data)
  );